export default "__VITE_ASSET__CUgAlmy3__"